import classNames from 'classnames';
import React from 'react';
import { PageButton } from '../page-button';
export const PageButtons = ({ currentPage, totalPages, onChange, isDisabled }) => {
    // Create an array with the pagenumbers of totalPages' length.
    // which results in: [ 0: 1, 1: 2, 2: 3]
    const pageArray = Array.from({ length: totalPages }, (_1, k) => k + 1);
    // We only want to show dots once before the currentPage and after the currentPage.
    // Hence we need an extra var `showingDots` to know it we're showing dots or not.
    let showingDots = false;
    return (React.createElement(React.Fragment, null, pageArray.map((page) => {
        let showButton = false;
        let showDots = false;
        // Show the button for the current page
        // Show the button on the first and last page
        // Show the button when the page is current-1 and current+1
        if (page === currentPage ||
            page === 1 ||
            page === totalPages ||
            page + 1 === currentPage ||
            page - 1 === currentPage) {
            showButton = true;
        }
        // When at page 4, start dotting low numbers.
        // Start dotting when current page is not beyond last page - 2
        if ((!showButton && currentPage >= 4) || (!showButton && currentPage < totalPages - 2)) {
            showDots = true;
        }
        // Expected results:
        // 1 2 3 ... 12 => 2 active
        // 1 ... 6 7 8 ... 12 => 7 active
        // 1 ... 11 12  => 12 active
        // If there is a button to show, show it!
        if (showButton) {
            // We're showing a page button, reset the showingDots var because we're not actively showing dots.
            showingDots = false;
            return (React.createElement(PageButton, { key: page, page: page, onClick: onChange, isDisabled: isDisabled || page === currentPage, isActive: page === currentPage, testId: `pagination-btn-${page}`, className: classNames({
                    current: page === currentPage, // Add a class so we can easily style this button om mobile view.
                }) }));
        }
        // If we want to show dots, and are not showing dots already, and don't want to show a button.
        if (showDots && !showingDots) {
            // We're showing dots so set this to true to prevent the showing of dots for each hidden button.
            // Also, dot buttons are always disabled
            showingDots = true;
            return React.createElement(PageButton, { key: page, label: "...", isDisabled: true, testId: "pagination-btn-dots", className: "dots" });
        }
        return null;
    })));
};
//# sourceMappingURL=page-buttons.js.map